export const extractToolResultText = (content: unknown): string | null => {
  if (typeof content === 'string') return content;
  if (Array.isArray(content) && content.length > 0) {
    const first = content[0] as Record<string, unknown>;
    if (typeof first?.text === 'string') return first.text;
  }
  return null;
};
